import { Injectable } from "@angular/core";
import { ApiService } from "@meddatacore/common";
import { Observable } from "rxjs";
import { AreaType } from "../../enums";
import { AreaGeometry, DataSourceResponse } from "../../models";
import { HttpParamsEncoder } from "../../tools";

@Injectable({
    providedIn: 'root',
})
export class AreaGeometryService extends ApiService {
    endPoint = '/api/AreaGeometry';
    create(model: AreaGeometry) {
        return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
    }

    update(model: AreaGeometry) {
        return this.http.put(`${this.commonBaseURL}${this.endPoint}`, model);
    }

    delete(id: string) {
        return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
    }
    deleteRange(ids: string[]) {
        return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/delete-range`, ids);
    }

    get(id: string): Observable<AreaGeometry> {
        return this.http.get<AreaGeometry>(`${this.commonBaseURL}${this.endPoint}/${id}`);
    }

    getAreas(queryParams?: any): Observable<DataSourceResponse<AreaGeometry>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
    }

    getAreasByParent(parentId: string): Observable<AreaGeometry[]> {
        return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}/parent/${parentId}/area-geometries`);
    }

    getAreaByAreaId(areaId: string): Observable<AreaGeometry> {
        return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}/area/${areaId}/area-geometry`);
    }
    
    getAreaByAreaType(areaType: AreaType): Observable<AreaGeometry> {
        return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}/area/type/${areaType}/area-geometry`);
    }

}